// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3ofPO","empty":"ModalGraph_empty__2LW7W"};